import React, { createContext, useState } from 'react';

export const NavigationSidebarContext = createContext();

export function NavigationSidebarProvider({ children }) {
  const [isNavigationSidebarOpen, setNavigationSidebarOpen] = useState(true);
  return (
    <NavigationSidebarContext.Provider value={{ isNavigationSidebarOpen, setNavigationSidebarOpen }}>
      {children}
    </NavigationSidebarContext.Provider>
  );
}